// Brand mark: a water droplet (what the company protects) with a flame-shaped
// highlight (the "Agni" in the name) and flowing waves for treated water.
export function LogoMark({ className = 'h-11 w-11' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="agni-drop" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ef4c52" />
          <stop offset="100%" stopColor="#ae1920" />
        </linearGradient>
        <clipPath id="agni-clip">
          <path d="M32 3C32 3 9 28.5 9 41.5C9 54.2 19.3 62 32 62C44.7 62 55 54.2 55 41.5C55 28.5 32 3 32 3Z" />
        </clipPath>
      </defs>
      <path
        d="M32 3C32 3 9 28.5 9 41.5C9 54.2 19.3 62 32 62C44.7 62 55 54.2 55 41.5C55 28.5 32 3 32 3Z"
        fill="url(#agni-drop)"
      />
      <g clipPath="url(#agni-clip)">
        <path d="M4 44c6-4 12-4 18 0s12 4 18 0 12-4 18 0v24H4z" fill="#ffffff" opacity="0.95" />
        <path d="M4 52c6-4 12-4 18 0s12 4 18 0 12-4 18 0v16H4z" fill="#9ca3af" opacity="0.55" />
      </g>
      {/* flame highlight */}
      <path
        d="M27 36c-3-4-2-9 2-13 0 4 3 5 3 8 1-2 1-4 0-6 4 3 6 8 3 12-2 2-6 2-8-1z"
        fill="#ffffff"
        opacity="0.9"
      />
    </svg>
  );
}

export default function Logo({ light = false, showTagline = false, compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark className={compact ? 'h-9 w-9' : 'h-11 w-11'} />
      <span className="leading-none">
        <span
          className={`block font-display font-bold tracking-wide ${compact ? 'text-lg' : 'text-xl'} ${
            light ? 'text-white' : 'text-ink'
          }`}
        >
          AGNI<span className="text-brand-600">SAFE</span>
        </span>
        <span
          className={`mt-1 block text-[0.6rem] font-semibold uppercase tracking-[0.32em] ${
            light ? 'text-gray-300' : 'text-gray-500'
          }`}
        >
          Engineering LLP
        </span>
        {showTagline && (
          <span className="mt-1.5 block text-[0.65rem] italic text-brand-400">
            Pure Water. Sustainable Tomorrow.
          </span>
        )}
      </span>
    </span>
  );
}
